import "../App.css";
import Header from "../screens/Header";
import PrivacyPolicyScreen from "../screens/PrivacyPolicyScreen";
import Footer from "../screens/Footer";
import ScrollUpBtn from "../components/ScrollUpBtn";

function PrivacyPolicy() {
  return (
    <div className="App">
      <Header />
      <PrivacyPolicyScreen />
      <Footer />
      <ScrollUpBtn />
    </div>
  );
}

export default PrivacyPolicy;
